import React, { FC, memo, useMemo } from 'react';

import Tag from '@components/vaults/Tag';

import {
  FarmsFilterTab,
  RANGES,
  V3FarmsFilterTab,
} from '@constants/vaults/common.constants';

import useStyles from './styles.module';

interface Props {
  list: { label: string; value: string }[];
  farmTypes: (string | number)[] | string | undefined;
  onClick: (value: { label: string; value: string }) => void;
  className?: string;
  v3Type: string | undefined;
}

const Ranges: FC<Props> = ({ list, farmTypes, onClick, className, v3Type }) => {
  const { classes, cx } = useStyles();

  const isDisabled = useMemo(
    () =>
      !!(farmTypes?.length && !farmTypes.includes(FarmsFilterTab.V3)) ||
      v3Type === V3FarmsFilterTab.Ailm,
    [v3Type, farmTypes],
  );

  return (
    <div className={cx(classes.list, className)}>
      {RANGES.map(({ label, value }) => {
        const checked = list.some((item) => item.value === value);

        return (
          <Tag
            key={label}
            title={label}
            checked={checked}
            disabled={isDisabled}
            className={classes.tagItem}
            onClick={() =>
              onClick({
                label,
                value,
              })
            }
          />
        );
      })}
    </div>
  );
};

export default memo(Ranges);
